/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".panel-body[_ngcontent-%COMP%] {\n  padding: 15px !important;\n}\n#historyGridContainer[_ngcontent-%COMP%] {\n  font-family: \"Open Sans\",sans-serif !important;\n  font-size: 16px !important;\n}\n#historyGridContainer.dateLink[_ngcontent-%COMP%] {\n    color: #3F8F8B !important;\n    text-decoration: none !important;\n    font-weight: 600 !important;\n  }\n.dx-datagrid-headers[_ngcontent-%COMP%]   .dgHeader[_ngcontent-%COMP%] {\n  color: #3F8F8B !important;\n  text-decoration: none !important;\n  font-weight: 600 !important;\n}\n#historyGridChart[_ngcontent-%COMP%]{\n  height: 350px;\n}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/history-container/history-container.component.css.shim.ngstyle.js.pre-build-optimizer.js